module.exports = __webpack_public_path__ + "media/audios/kid/lesson_9/audio53-6002ebba178dc9124777e077d771fdbc.m4a";